export const SET_API_TOKEN = "auth/set_api_token";
